import { useCallback, useEffect, useState } from 'react';
import TierPart from './TierPart';
import { TIER_SCOPES } from './TierConsts';
import { TIER_FIELDS } from '../../../../common/fields';

const { TIER } = TIER_FIELDS;

const Tier = ({ dispatch, save, fields, updateAction, isDcDrawerOpen, closeDcDrawer }) => {
    const [openDrawerScope, setOpenDrawerScope] = useState();
    const dispatchUpdate = useCallback(
        (value) => {
            dispatch({
                type: updateAction,
                payload: { value }
            });
            save();
        },
        [dispatch, updateAction, save]
    );

    const updateTierPart = (part, partValue) => {
        const tierValue = fields[TIER.ID].value;
        dispatchUpdate({ ...tierValue, [part]: partValue });
    };

    useEffect(() => {
        if (isDcDrawerOpen) {
            setOpenDrawerScope(TIER_SCOPES.DCS);
        }
    }, [isDcDrawerOpen]);

    useEffect(() => {
        if (closeDcDrawer && openDrawerScope && openDrawerScope !== TIER_SCOPES.DCS) {
            closeDcDrawer();
        }
    }, [openDrawerScope, closeDcDrawer]);

    return (
        <div>
            {fields[TIER.ID] && (
                <div>
                    <div className="h-12 content-center text-14 font-medium">Resources</div>
                    <div className="w-full grid grid-cols-2 gap-4">
                        <TierPart
                            tierPartConfig={fields[TIER.ID].value[TIER_SCOPES.IN_SCOPE]}
                            updateTierPart={updateTierPart}
                            scope={TIER_SCOPES.IN_SCOPE}
                            openDrawerScope={openDrawerScope}
                            setOpenDrawerScope={setOpenDrawerScope}
                            emptyStateDescription="Add assets and selected specific services"
                        />
                        <TierPart
                            tierPartConfig={fields[TIER.ID].value[TIER_SCOPES.OUT_SCOPE]}
                            updateTierPart={updateTierPart}
                            scope={TIER_SCOPES.OUT_SCOPE}
                            openDrawerScope={openDrawerScope}
                            setOpenDrawerScope={setOpenDrawerScope}
                            emptyStateDescription="Add assets"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Tier;
